import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { CourseService } from '../../../services/course.service';

@Component({
  selector: 'app-delete-course',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './delete-course.component.html',
  styleUrl: './delete-course.component.scss'
})
export class DeleteCourseComponent {
  @Input() courseData: any;
  @Output() closeDialog = new EventEmitter<boolean>();
  @Input() reload = new EventEmitter<boolean>();

  visible: boolean = true;
  loading: boolean = false;

  constructor(
    private api: CourseService,
    private messageService: MessageService
  ) {}

  handleDelete() {
    this.loading = true;
    const payload = {
      organization_id: this.courseData.organization_id,
      course_id: this.courseData.course_id
    };
    this.api.deleteCourse(payload).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Course deleted successfully.'
        });
        this.loading = false;
        this.reload.emit();
        this.handleCloseDialog();
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.error.message || 'Failed to delete course.'
        });
        this.loading = false;
      }
    });
  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }
}
